import cx from "classnames";
import type { ReactElement } from "react";
import { useEffect, useState } from "react";

type Props = Readonly<{
  isEnabled?: boolean;
  onChange?: (isEnabled: boolean) => void;
}>;

export default function ToggleSwitch({
  isEnabled = false,
  onChange,
}: Props): ReactElement {
  const [isActive, setIsActive] = useState(isEnabled);

  useEffect(() => {
    setIsActive(isEnabled);
  }, [isEnabled]);

  const handleToggle = () => {
    const newIsActive = !isActive;
    setIsActive(newIsActive);
    if (onChange) {
      onChange(newIsActive);
    }
  };

  return (
    <button
      id="toggle-switch"
      className={cx(
        "h-inherit relative w-[50px] cursor-pointer rounded-full p-0.5 transition-all duration-300 ease-in-out",
        {
          "bg-brand-primary": isActive,
          "bg-background-secondary-on-dark": !isActive,
        },
      )}
      onClick={handleToggle}
      data-testid="toggle-switch"
      aria-label="toggle-switch"
      tabIndex={0}
    >
      <div
        className={cx(
          "bg-background-default h-6 w-6 rounded-full transition-transform duration-300 ease-in-out",
          {
            "translate-x-[90%] transform": isActive,
            "translate-x-0 transform": !isActive,
          },
        )}
      />
    </button>
  );
}
